import styled from 'styled-components';

export const Title = styled.div`
	color: #fff;

	font-family: 'Nunito Sans';
	font-size: 11px;
	font-style: normal;
	font-weight: 700;
	line-height: 120%; /* 13.2px */
`;

export const Subtitle = styled.div`
	color: #fff;

	font-family: 'Nunito Sans';
	font-size: 9px;
	font-style: normal;
	font-weight: 400;
	line-height: 120%; /* 10.8px */
`;

export const CookieElementConsentWrapper = styled.div`
	display: flex;
	justify-content: left;
	width: 90vw;
	gap: 14px;

	max-width: 680px;

	@media (min-width: 600px) {
		flex-direction: row-reverse;
		justify-content: space-between;
	}
`;

export const CookieConsentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;
